// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__182jA","label":"LabeledBox_label__14DvF"};